import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbTextInput } from "abreact/input/AbTextInput";
import { AbButton } from "abreact/misc/AbButton";
import { AbIcon } from "abreact/misc/AbIcon";
import { AbSize, AbSizeContext, sizeProviderWrapper } from "abreact/misc/AbSize";
import * as React from "react";

/**
 * Common props go on the decorator div. Use iconCommonProps to put common props directly on the icon.
 */

const IconButtonDecorator = props => {
  return /*#__PURE__*/React.createElement(AbButton, _extends({}, props, {
    className: ReactUtils.classNamesString(["ab-no-border-button", props?.className])
  }));
};
const IconDecorator = props => {
  const commonProps = ReactUtils.extractCommonProps(props);
  const componentProps = ReactUtils.componentProps("ab-text-input-icon-decorator", commonProps);
  const {
    iconCommonProps,
    ...rest
  } = ReactUtils.extractNonCommonProps(props);
  return /*#__PURE__*/React.createElement("div", componentProps, /*#__PURE__*/React.createElement(AbIcon, _extends({}, iconCommonProps, rest)));
};
export function AbDecoratedTextInput(props) {
  const commonProps = ReactUtils.extractCommonProps(props);
  const {
    value,
    onChange,
    textInputProps,
    size,
    decorators,
    abRef,
    onFocus,
    onBlur
  } = ReactUtils.extractNonCommonProps(props);
  const contextSize = React.useContext(AbSizeContext);
  const componentProps = ReactUtils.componentProps("ab-decorated-text-input", commonProps, [size ?? contextSize ?? AbSize.MEDIUM, decorators.length > 0 && "ab-decorated-text-input-has-decorators"]);
  const style = {
    "--ab-text-input-decorators-count": decorators.length,
    ...componentProps.style
  };
  const textInputClassName = ReactUtils.classNamesString([textInputProps?.className, "ab-default-input-width"]);
  const inner = /*#__PURE__*/React.createElement("div", _extends({}, componentProps, {
    style: style,
    ref: abRef,
    onFocus: onFocus,
    onBlur: onBlur
  }), /*#__PURE__*/React.createElement(AbTextInput, _extends({
    value: value,
    onChange: onChange
  }, textInputProps, {
    className: textInputClassName
  })), decorators.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "ab-decorated-text-input-decorators"
  }, decorators.map(decoratorProps => {
    if (decoratorIsButton(decoratorProps)) {
      return /*#__PURE__*/React.createElement(IconButtonDecorator, _extends({}, decoratorProps, {
        key: decoratorProps.key ?? decoratorProps.icon
      }));
    } else if (decoratorIsIcon(decoratorProps)) {
      return /*#__PURE__*/React.createElement(IconDecorator, _extends({}, decoratorProps, {
        key: decoratorProps.key ?? decoratorProps.image
      }));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: decoratorProps.key
      }, decoratorProps.content);
    }
  })));
  return sizeProviderWrapper(inner, props, contextSize);
}
const decoratorIsIcon = decorator => {
  return "image" in decorator;
};
const decoratorIsButton = decorator => {
  return "onClick" in decorator;
};
//# sourceMappingURL=AbDecoratedTextInput.js.map
